module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAuUlEQVR4nO2XQQ7CMAwE58SfgPfRwrfgK8AL4l6DDK0UVSlprJQD8kqWoijxxus9OFCJCDuBi8AzwEOg1z22hsBZIM6i25w4fKqMAxwGOOpa95okj4mcmereoaQTcS5MbZC8nNboLHLuM4/KEszPaSuq2yALycZH3TKyXmvz0OTCApy4CJfaCjdXEW4uK9xcRbi5/t9cIZkkraTJBHpffUmnw4bD3mk18Tje9lPlltBKlfQnvwwHX/ACFAhn5AgS/wEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/icon-paste-sp.png
// module id = EBeA
// module chunks = 41